export type CountryCode = 'PT' | 'BR'

export interface CountryOption {
  code: CountryCode
  flag: string
  dial: string
  label: string
}

export const COUNTRY_OPTIONS: CountryOption[] = [
  { code: 'PT', flag: '🇵🇹', dial: '+351', label: 'Portugal' },
  { code: 'BR', flag: '🇧🇷', dial: '+55', label: 'Brasil' },
]

export function getCountryDial(code: CountryCode): string {
  return code === 'BR' ? '+55' : '+351'
}

export function detectCountryFromPhone(value: string | null | undefined): CountryCode {
  const v = (value ?? '').trim()
  if (v.startsWith('+55')) return 'BR'
  return 'PT'
}

/**
 * Aplica máscara ao telefone conforme o país.
 * - PT: +351 912 345 678
 * - BR: +55 (11) 91234-5678
 *
 * A string de entrada pode ter qualquer formatação; serão usados apenas os dígitos.
 */
export function formatPhone(raw: string, country: CountryCode): string {
  const digits = raw.replace(/\D/g, '')

  if (!digits) return ''

  if (country === 'PT') {
    const local = digits.replace(/^351/, '').slice(0, 9)

    const parts: string[] = []
    if (local.length <= 3) {
      parts.push(local)
    } else if (local.length <= 6) {
      parts.push(local.slice(0, 3), local.slice(3))
    } else {
      parts.push(local.slice(0, 3), local.slice(3, 6), local.slice(6))
    }

    return parts.filter(Boolean).join(' ')
  }

  if (country === 'BR') {
    const local = digits.replace(/^55/, '').slice(0, 11)
    const ddd = local.slice(0, 2)
    const first = local.slice(2, 7)
    const last = local.slice(7)

    if (!ddd) return ''
    if (local.length <= 2) return `(${ddd}`
    if (local.length <= 7) return `(${ddd}) ${first}`
    return `(${ddd}) ${first}-${last}`
  }

  return raw
}

export function buildPhoneForStorage(localFormatted: string, country: CountryCode): string {
  const localDigits = localFormatted.replace(/\D/g, '')
  if (!localDigits) return ''
  const local = formatPhone(localDigits, country)
  const dial = getCountryDial(country)
  return local ? `${dial} ${local}` : dial
}

